export interface BattleTutorialSequence {
  speaker: string;
  role: string;
  portraitId: string;
  lines: readonly string[];
}

const CHAPTER_ONE_LINES: Readonly<Record<number, readonly string[]>> = Object.freeze({
  1: Object.freeze([
    "さて、ここからは実地だ。《窓》へ触れる手順を、一つずつやってみよう。",
    "演出卓の《雲のゆりかご》を選んで中央のレーンへ置く。札には必要な演出力が記されている。注目もL2へ合わせてから、その手で進んで。",
  ]),
  2: Object.freeze([
    "よし。今ので、夢を一つ置いて、ご主人の視線を向けられた。",
    "ここから先は自由だ。基本札は何度でも使えるが、舞台札は一夜に一度。札を使わず、注目だけを動かしてもいい。ただし一時間に隣のレーンまで。",
  ]),
  3: Object.freeze([
    "夢は時間の終わりにD3からD2、D1へ浅くなる。その次には《窓》から消える。",
    "同じ夢でも、深度によって幸福度への影響が違う。今だけじゃなく、次の時間も見て選ぶんだ。",
  ]),
  4: Object.freeze([
    "ご主人に届くのは、注目しているレーンの夢だけだ。二人の注目が重なれば、同じ夢を一緒に見る。",
    "同じマスへ夢が重なったときは合体する。プラスとマイナスも、その場の値で足し合わされるよ。",
  ]),
  5: Object.freeze([
    "献身は、一夜に一度だけ使える、しもべ自身の手つきだ。",
    "今夜の君は、私の《口火を切る》を真似できる。影響の絶対値が1〜3の夢を選べば、その時間だけ符号方向へ2強められる。",
  ]),
});

export function getChapterOneTutorial(
  turn: number,
  happiness: number,
): BattleTutorialSequence | null {
  const lines = turn === 6
    ? Object.freeze([
      "これが最後の一時間だ。男の幸福度は今" + happiness + "。",
      "13〜15ならよりよい朝、16以上なら寝坊、0以下なら悪夢になる。最後の手は、自分で決めて。",
    ])
    : CHAPTER_ONE_LINES[turn];
  if (!lines) return null;
  return {
    speaker: "《火打石》",
    role: "先輩のしもべ",
    portraitId: "flint",
    lines,
  };
}
